import React, { useState, useRef, useEffect } from "react";
import Menu from "../../components/layout/menu/index";
import '../../../src/index.css'
import Pagination from "../../components/shared/pagination";
import { getNotifications } from "../../client/notifications";
import { useAuth } from "../../context/auth";

export default function HistoricNotification() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalNotifications: 0,
    totalPages: 1
  });

  const [selectedPageSize, setSelectedPageSize] = useState(10);


  const { supplierId } = useAuth();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const fetchNotifications = async (page = 1, pageSize = selectedPageSize) => {
    if (!supplierId) {
      setError("No se encontró el ID del proveedor");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await getNotifications(Number(supplierId), page, pageSize);
      setNotifications(response.notifications);
      setPagination(response.pagination);
      setError(null);
    } catch (err) {
      setError("Error al cargar las notificaciones");
      console.error("Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications(1, selectedPageSize);
  }, [supplierId, selectedPageSize]);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      fetchNotifications(newPage, selectedPageSize);
    }
  };

  const handleRecordsPerPageChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setSelectedPageSize(newPageSize);
  };

const formatDate = (dateString) => {
  const date = new Date(dateString);
  date.setTime(date.getTime() - (5 * 60 * 60 * 1000));
  
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

const formatTime = (dateString) => {
  const date = new Date(dateString);
  date.setTime(date.getTime() - (5 * 60 * 60 * 1000));
  
  return date.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).toUpperCase();
};


  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-4 pb-10 flex flex-col  px-[3%]">
            <h1 className="text-2xl md:text-[32px] mb-4 text-blue font-itcbold">
                Histórico de notificaciones
            </h1>
            {pagination.totalPages > 0 && (
            <div className="flex items-center justify-between my-4">
                <div className="flex items-center space-x-2 text-sm font-itcbook">
                    <p >Mostrar</p>
                    <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                    <select
                        className="w-full h-full px-2 text-sm bg-white rounded-md outline-none font-itcbook"
                        value={selectedPageSize}
                      onChange={handleRecordsPerPageChange}  
                    >
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    </div>
                    <p >Registros</p>
                </div>
            </div>
            )}

          {loading && notifications.length === 0 ? (
            <div className="flex items-center justify-center h-64">
              <div className="w-12 h-12 border-b-2 rounded-full animate-spin border-blue"></div>
            </div>
          ) : notifications.length === 0 ? (
            <div className="w-full p-8 text-center text-gray-500 bg-white font-itcmedium">
              No hay notificaciones disponibles
            </div>
          ) : (
            <div className="space-y-2">
            {notifications.length === 0 && !loading ? (
                <div className="w-full p-8 text-center text-gray-500 bg-white font-itcmedium">
                No hay notificaciones disponibles
                </div>
            ) : (
                <div className="space-y-2">
                {notifications.map((notification) => (

                <div key={notification.id} className="bg-white w-full gap-2 p-3 items-center flex min-h-[87px] ">
                    <div className="flex items-start justify-between w-full">
                        <div className="flex gap-3">
                            <div>
                              <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 13.5C0 6.04416 6.04415 0 13.5 0H15.5769C23.0328 0 29.0769 6.04416 29.0769 13.5C29.0769 20.9558 23.0328 27 15.5769 27H13.5C6.04416 27 0 20.9558 0 13.5Z" fill="#184A7D"/>
                              <path d="M8.13672 19.3688L14.5367 12.9688L19.8701 19.3688" stroke="white" stroke-width="2"/>
                              <path d="M14.5372 5.5L6.00391 10.8333V21.5H23.0706V9.76667L14.5372 5.5Z" stroke="white" stroke-width="2"/>
                              <path d="M6.00391 10.8359L11.3372 15.1026" stroke="white" stroke-width="2"/>
                              <path d="M23.0716 10.8359L17.7383 15.1026" stroke="white" stroke-width="2"/>
                              </svg>
                            </div>
                            <div className="flex flex-col gap-2 text-sm">
                                <p className="font-itcbold ">
                                    {notification.title}
                                </p>
                                <p className="font-itcmedium text-[#3F3F3F]">
                                    {notification.description}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col text-sm font-itcmedium text-gray">
                            <p>{formatDate(notification.created_At)}</p>
                            <p>{formatTime(notification.created_At)}</p>
                        </div>
                    </div>
                </div>
                ))}
                </div> 
            )}

            {pagination.totalPages > 0 && (
                <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                changePage={changePage}
                recordsPerPage={pagination.pageSize}
                totalRecords={pagination.totalNotifications}
                />
            )}
            </div>   
            )}        
        </div>
      </div>
    </div>
  );
}